module.exports = require("./../../_gen/starling/extensions/ColorArgb");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/extensions/ColorArgb.js
// module id = 190
// module chunks = 0